import { useQuery } from "react-query";
import { countriesService } from "../services/countries.service";

export function useCountriesAsSelectOptionsQuery() {
    return useQuery(
        ["countries-options"],
        () => countriesService.getCountriesAsSelectOptions()
    )
}